var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { TerminalIcon } from '@heroicons/react/outline';
import { Alert, icons } from '@showroomjs/ui';
import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useStableCallback } from '../lib/callback';
import { useCodeCompilation } from '../lib/use-code-compilation';
import { Div, Span } from './base';
import { CodePreview } from './code-preview';
import { ErrorFallback } from './error-fallback';
export const CodePreviewFrame = React.forwardRef(function CodePreviewFrame(_a, forwardedRef) {
    var { code, lang, nonVisual, onIsCompilingChange } = _a, divProps = __rest(_a, ["code", "lang", "nonVisual", "onIsCompilingChange"]);
    const errorBoundaryRef = React.useRef(null);
    const { data, isCompiling, error, isError } = useCodeCompilation(code, lang);
    const onIsCompilingChangeCb = useStableCallback(onIsCompilingChange);
    React.useEffect(() => {
        onIsCompilingChangeCb(isCompiling);
    }, [isCompiling]);
    React.useEffect(() => {
        if (errorBoundaryRef.current) {
            errorBoundaryRef.current.reset();
        }
    }, [code]);
    return (React.createElement(Div, Object.assign({ css: {
            position: 'relative',
            padding: nonVisual ? 0 : '$1',
            minHeight: nonVisual ? 0 : 30,
            backgroundColor: 'White',
        } }, divProps, { ref: forwardedRef }),
        isError ? (React.createElement(Alert, { variant: "error" }, typeof error === 'string' ? error : 'Compilation error')) : (data &&
            (data.type === 'success' ? (React.createElement(ErrorBoundary, { FallbackComponent: ErrorFallback, ref: errorBoundaryRef },
                React.createElement(CodePreview, Object.assign({}, data, { skipConsoleForInitialRender: lang === 'html' })))) : (React.createElement(Alert, { variant: "error" }, formatError(data.error))))),
        isCompiling && !nonVisual && (React.createElement(Div, { css: {
                position: 'absolute',
                right: 0,
                top: 0,
                bottom: 0,
                px: '$4',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(229, 231, 235, 0.1)',
                gap: '$2',
            } },
            React.createElement(TerminalIcon, { width: "20", height: "20", className: icons() }),
            React.createElement(Span, { css: {
                    color: '$gray-500',
                } }, "Compiling...")))));
});
const formatError = (error) => error.replace(/<stdin>:|\"\\x0A\"/g, '');
//# sourceMappingURL=code-preview-frame.js.map